import {Address} from './address';

export class Guest {
   id: string;
   guestFullName: string;
   guestAddress: Address;
}
